import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/free-tools/[lang]/api-pricing-calculator/form.tsx");
